// Year and month of a stored date, read in UTC. Payment and expense dates are stored at
// UTC midnight, so local time would move 1 January into the year before for anyone west
// of Greenwich (the same reason displayDate.ts pins its formatter). Built-in Intl only.
const MONTH_FORMAT = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

export function utcYear(iso: string): number {
  return new Date(iso).getUTCFullYear();
}

// "2026-09": groups rows by calendar month.
export function utcMonthKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

// "September 2026": the heading over a month's rows.
export function formatUtcMonth(iso: string): string {
  return MONTH_FORMAT.format(new Date(iso));
}
